import type { PropsWithChildren } from 'react';
import React, { createContext, useContext, useMemo } from 'react';
import type {
  DraggableCollectionState,
  DroppableCollectionState,
} from 'react-stately';
import type { DragAndDropHooks } from './useDragAndDrop';

export type DragAndDropContextValue = {
  dragState?: DraggableCollectionState;
  dropState?: DroppableCollectionState;
  dragAndDropHooks?: DragAndDropHooks;
};

const DragAndDropContext = createContext<DragAndDropContextValue>({});

export function useDragAndDropContext() {
  return useContext(DragAndDropContext);
}

export function DragAndDropProvider({
  children,
  dragState,
  dropState,
  dragAndDropHooks,
}: PropsWithChildren<DragAndDropContextValue>) {
  const context = useMemo(() => {
    return {
      dragState,
      dropState,
      dragAndDropHooks,
    };
  }, [dragState, dropState, dragAndDropHooks]);

  return (
    <DragAndDropContext.Provider value={context}>
      {children}
    </DragAndDropContext.Provider>
  );
}
